import { safePageParameters } from './analyticsPrivacy.js';

export function reportClientError(error, context = {}) {
  if (typeof window === 'undefined') return;

  const message = ['TypeError', 'ReferenceError', 'RangeError', 'SyntaxError'].includes(error?.name) ? error.name : 'ClientError';
  const scope = ['window-error', 'unhandled-rejection', 'client'].includes(context.scope) ? context.scope : 'client';

  // Send sanitized error info to GA4 if available (no console output).
  try {
    if (window.gtag) {
      window.gtag('event', 'exception', {
        description: `${scope}: ${message}`,
        fatal: Boolean(context.fatal),
        ...safePageParameters(window.location, document.referrer),
      });
    }
  } catch {
    // Intentionally swallow to avoid recursive client failures.
  }

  // Optional first-party endpoint if configured (e.g. Netlify Function/API route).
  const endpoint = process.env.GATSBY_CLIENT_ERROR_ENDPOINT;
  if (!endpoint) return;

  const payload = JSON.stringify({
    scope,
    message,
    fatal: Boolean(context.fatal),
    page: window.location?.pathname || '',
    timestamp: new Date().toISOString(),
  });

  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(endpoint, payload);
      return;
    }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Intentionally swallow to avoid recursive client failures.
  }
}
